import {Box, Typography} from '@mui/material';
import TtsManagementSection from '../components/tts/TtsManagementSection.tsx';

export default function TtsManagementPage() {
    return (
        <Box sx={{p: 3}}>
            <Typography variant="h5" gutterBottom>
                TTS 음성 관리
            </Typography>
            <TtsManagementSection/>
        </Box>
    );
}
